import api from "./index.js";

export function getDex(pairAddress) {
    return api.get("api/dex", {
        params: {
            symbol: pairAddress,
        },
    });
}
